import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Switch,
  message,
  Typography,
} from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { getErrorMessages } from 'app/utils/functions';
import { buildTsaTrialPublicLink } from '../publicLink';
import { getTsaTrialPeriod, saveTsaTrialPeriod } from '../service';
import AdminFormFieldsEditor from '../Components/AdminFormFieldsEditor';
import AdminHtmlEditor from '../Components/AdminHtmlEditor';
import {
  MESSAGE_LABELS,
  apiItemToFormValues,
  defaultFormValues,
  formValuesToApiPayload,
} from '../periodFormTransform';

const { Option } = Select;
const { Text } = Typography;

class AdminTsaTrialPeriodForm extends Component {
  formRef = React.createRef();

  state = {
    id: null,
    loading: false,
    saveLoading: false,
    code: '',
  };

  componentDidMount() {
    const id =
      this.props.match?.params?.id != null ? this.props.match.params.id : null;
    if (id) {
      this.setState({ id });
      this.loadItem(id);
    } else {
      this.formRef.current?.setFieldsValue(defaultFormValues());
    }
  }

  loadItem = async (id) => {
    this.setState({ loading: true });
    const response = await getTsaTrialPeriod(id);
    if (response.data.code === 200) {
      const item = response.data.data.item;
      this.setState({ code: item.code });
      this.formRef.current.setFieldsValue(apiItemToFormValues(item));
    } else {
      message.error(getErrorMessages(response.data));
      this.props.history.push('/admin/tsa-trial-periods');
    }
    this.setState({ loading: false });
  };

  back = () => {
    this.props.history.push('/admin/tsa-trial-periods');
  };

  onFinish = async (values) => {
    this.setState({ saveLoading: true });
    const data = formValuesToApiPayload(values, this.state.id);
    const response = await saveTsaTrialPeriod(data);
    if (response.data.code === 200) {
      message.success(response.data.message);
      this.props.history.push('/admin/tsa-trial-periods');
    } else {
      message.error(getErrorMessages(response.data));
    }
    this.setState({ saveLoading: false });
  };

  renderExamDates() {
    return (
      <Form.List name="exam_dates">
        {(rows, { add, remove }) => (
          <>
            {rows.map((row) => (
              <Space key={row.key} align="start" className="d-flex mb-2">
                <Form.Item
                  label="Ngày thi"
                  name={[row.name, 'date']}
                  rules={[{ required: true, message: 'Chọn ngày' }]}
                >
                  <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item
                  label="Nhãn hiển thị"
                  name={[row.name, 'label']}
                  rules={[{ required: true, message: 'Nhập nhãn' }]}
                  className="flex-grow-1"
                >
                  <Input placeholder="Thứ Bảy ngày 03/10/2026" />
                </Form.Item>
                {rows.length > 1 && (
                  <MinusCircleOutlined
                    className="mt-4"
                    onClick={() => remove(row.name)}
                  />
                )}
              </Space>
            ))}
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
              Thêm ngày thi
            </Button>
          </>
        )}
      </Form.List>
    );
  }

  render() {
    const { loading, saveLoading, code } = this.state;
    const isEdit = this.state.id !== null;
    const previewCode = code || this.formRef.current?.getFieldValue?.('code');

    return (
      <Container className="page-exam">
        <Row>
          <Col xs={12} lg={10}>
            <h3>{isEdit ? 'Sửa đợt đăng ký' : 'Thêm đợt đăng ký thi trải nghiệm'}</h3>
            <Form
              ref={this.formRef}
              layout="vertical"
              onFinish={this.onFinish}
              onValuesChange={(changed) => {
                if (changed.code !== undefined) {
                  this.setState({ code: changed.code });
                }
              }}
            >
              <Card title="Thông tin chung" className="mb-3">
                <Form.Item
                  label="Slug (đuôi link ẩn)"
                  name="code"
                  rules={[
                    { required: true, message: 'Vui lòng nhập slug' },
                    {
                      pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
                      message: 'Chỉ dùng chữ thường, số và dấu gạch ngang',
                    },
                  ]}
                >
                  <Input disabled={loading} placeholder="slug-link-dang-ky" />
                </Form.Item>
                {previewCode && (
                  <Text copyable={{ text: buildTsaTrialPublicLink(previewCode) }} className="d-block mb-3">
                    Link: {buildTsaTrialPublicLink(previewCode)}
                  </Text>
                )}
                <Form.Item
                  label="Tiêu đề trang đăng ký"
                  name="title"
                  rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Đoạn giới thiệu (đầu trang)"
                  name="intro"
                  rules={[{ required: true, message: 'Vui lòng nhập giới thiệu' }]}
                  extra="Soạn bằng trình WYSIWYG; hiển thị HTML trên trang đăng ký."
                >
                  <AdminHtmlEditor id="tsa-trial-intro" height={220} />
                </Form.Item>
                <Form.Item
                  label="Hạn đăng ký"
                  name="registration_deadline"
                  rules={[{ required: true, message: 'Chọn hạn đăng ký' }]}
                >
                  <DatePicker showTime format="DD/MM/YYYY HH:mm" className="w-100" />
                </Form.Item>
                <Form.Item label="Số lượng tối đa (để trống = không giới hạn)" name="max_registrations">
                  <InputNumber min={1} className="w-100" />
                </Form.Item>
                <Form.Item label="Trạng thái" name="status" rules={[{ required: true }]}>
                  <Select>
                    <Option value="0">Ẩn</Option>
                    <Option value="1">Mở đăng ký</Option>
                    <Option value="2">Đóng</Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Đánh dấu active" name="is_active" valuePropName="checked">
                  <Switch />
                </Form.Item>
              </Card>

              <Card title="Nội dung chương trình (HTML)" className="mb-3">
                <Form.Item
                  name="program_html"
                  rules={[{ required: true, message: 'Nhập nội dung chương trình' }]}
                  extra="Hiển thị dưới phần giới thiệu, trước biểu mẫu đăng ký."
                >
                  <AdminHtmlEditor id="tsa-trial-program" height={420} />
                </Form.Item>
              </Card>

              <Card title="Các ngày thi (lựa chọn trên form)" className="mb-3">
                {this.renderExamDates()}
              </Card>

              <Card title="Thông báo hệ thống" className="mb-3">
                {Object.entries(MESSAGE_LABELS).map(([key, label]) => (
                  <Form.Item key={key} label={label} name={['messages', key]}>
                    <Input />
                  </Form.Item>
                ))}
              </Card>

              <Card title="Các trường trên biểu mẫu đăng ký" className="mb-3">
                <AdminFormFieldsEditor />
              </Card>

              <Form.Item>
                <Button onClick={this.back} className="mr-2">
                  Quay lại
                </Button>
                <Button type="primary" htmlType="submit" loading={saveLoading}>
                  Lưu
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AdminTsaTrialPeriodForm;
